"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _state = require("@seedlang/state");
var _lodash = require("lodash");
var _utils = require("@seedlang/utils");
var _moment = _interopRequireDefault(require("moment"));
var _constants = require("@seedlang/constants");
var _src = require("@seedlang/utils/src");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var LIMIT = 20;
var ReviewIndexWrapper = function ReviewIndexWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _initializerDefineProperty(_this, "selected", _descriptor, _this);
      _initializerDefineProperty(_this, "view", _descriptor2, _this);
      _initializerDefineProperty(_this, "filtersExpanded", _descriptor3, _this);
      _initializerDefineProperty(_this, "userRequestIsPending", _descriptor4, _this);
      _initializerDefineProperty(_this, "loadInitialReviews", _descriptor5, _this);
      _initializerDefineProperty(_this, "selectedSort", _descriptor6, _this);
      _initializerDefineProperty(_this, "searchQuery", _descriptor7, _this);
      _initializerDefineProperty(_this, "caretPosition", _descriptor8, _this);
      _initializerDefineProperty(_this, "showFilterOptions", _descriptor9, _this);
      _initializerDefineProperty(_this, "expandedCardIds", _descriptor10, _this);
      _initializerDefineProperty(_this, "selectedCardIds", _descriptor11, _this);
      if (!_state.AppUI.cardTypeStore.hasIndexData) {
        _state.AppUI.cardTypeStore.getIndex({
          filters: {
            allow_reviews: true
          },
          sort: 'name'
        });
      }
      _this.disposer = (0, _mobx.autorun)(function () {
        if (_state.AppUI.userIsLoaded && !_this.loadInitialReviews) {
          _this.loadInitialReviews = true;
          _this.disposer && _this.disposer();
          _this.getReviews();
          _this.filtersExpanded = !_state.AppUI.user.moduleIsContracted('review-filters');
        }
      });
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (!_state.AppUI.layout.isNative && window.location.href) {
          var page = window.location.href.split('page/')[1];
          _state.AppUI.cardStore.setPage(page);
        }
        _state.AppUI.createEvent('reviews - view reviews list');
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        if (!_state.AppUI.cardStore.hasIndexData && _state.AppUI.cardStore.requestCounter === 0) {
          this.loadInitialReviews = true;
          this.getReviews();
        }
      }
    }, {
      key: "filteredItemsCount",
      get: function get() {
        return _state.AppUI.cardStore.hasIndexData ? _state.AppUI.cardStore.indexData[0].cardsCount : 0;
      }
    }, {
      key: "noFiltersSelectedMessage",
      get: function get() {
        return 'No Filter Selected.';
      }
    }, {
      key: "sortNonArchivedFirst",
      value: function sortNonArchivedFirst(ary) {
        return ary.sort(function (a, b) {
          return a.archived === b.archived ? 0 : a.archived ? 1 : -1;
        });
      }
    }, {
      key: "reviewDeckToOption",
      value: function reviewDeckToOption(reviewDeck) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
          withLanguage: false
        };
        return [reviewDeck.id, this.reviewDeckName(reviewDeck.id, params)];
      }
    }, {
      key: "reviewDeckOptions",
      get: function get() {
        var _this$sortNonArchived,
          _this2 = this;
        return (_this$sortNonArchived = this.sortNonArchivedFirst(_state.AppUI.reviewDeckStore.indexData.filter(function (item) {
          return item.languageId === _state.AppUI.targetLanguageId;
        }))) === null || _this$sortNonArchived === void 0 ? void 0 : _this$sortNonArchived.map(function (item) {
          return _this2.reviewDeckToOption(item);
        });
      }
    }, {
      key: "cardDeckIsArchived",
      value: function cardDeckIsArchived(card) {
        var _AppUI$reviewDeckStor;
        return (_AppUI$reviewDeckStor = _state.AppUI.reviewDeckStore.indexData.find(function (item) {
          return item.id === card.deckId;
        })) === null || _AppUI$reviewDeckStor === void 0 ? void 0 : _AppUI$reviewDeckStor.archived;
      }
    }, {
      key: "filterSettings",
      get: function get() {
        var _AppUI$cardTypeStore$,
          _this3 = this;
        var settings = [{
          multiSelect: true,
          key: 'deck_id',
          userKey: 'reviewsFilterDeckId',
          label: 'Review Deck',
          includeBlank: true,
          options: this.reviewDeckOptions,
          filterType: 'select'
        }, {
          key: 'retired',
          userKey: 'reviewsFilterRetired',
          label: 'Retired',
          includeBlank: true,
          description: 'Cards that are retired will not show up in your reviews by default. Cards are retired after you have seen them long enough that we consider them to be learned.',
          options: [[true, 'Yes'], [false, 'No']],
          filterType: 'select'
        }, {
          hide: true,
          key: 'created_at_days_ago',
          userKey: 'reviewsFilterCreatedAtDaysAgo',
          label: 'Created At',
          includeBlank: true,
          options: [[1, 'Last 1 Day'], [7, 'Last 7 Days'], [30, 'Last 30 Days'], [90, 'Last 90 Days']],
          filterType: 'select'
        }, {
          key: 'due',
          userKey: 'reviewsFilterDue',
          description: 'Cards are due to be reviewed at intervals that depend on your past experience with that card.',
          label: 'Next Due',
          includeBlank: true,
          options: [['past-due', 'Past Due'], ['caught-up', 'Caught Up']],
          filterType: 'select'
        }, {
          key: 'difficulty_label',
          userKey: 'reviewsFilterDifficultyLabel',
          description: 'We rank the difficulty of each card based on your experience with that card.',
          label: 'Difficulty',
          includeBlank: true,
          options: _constants.Constants.DIFFICULTY_LABEL_OPTIONS,
          filterType: 'select'
        }, {
          multiSelect: true,
          key: 'card_type_id',
          userKey: 'reviewsFilterCardTypeId',
          label: 'Card Type',
          includeBlank: true,
          options: (_AppUI$cardTypeStore$ = _state.AppUI.cardTypeStore.indexData) === null || _AppUI$cardTypeStore$ === void 0 ? void 0 : _AppUI$cardTypeStore$.map(function (item) {
            return [item.id, item.name];
          }),
          filterType: 'select'
        }];
        return settings === null || settings === void 0 ? void 0 : settings.map(function (item) {
          var _this3$selectedOrUser;
          var optionsAry = item.options.map(function (option) {
            return option[0];
          });
          var selectedOrUserAry = (0, _utils.isPresent)(_this3.selectedOrUser(item.userKey)) ? (0, _lodash.isString)(_this3.selectedOrUser(item.userKey)) && item.multiSelect ? (_this3$selectedOrUser = _this3.selectedOrUser(item.userKey)) === null || _this3$selectedOrUser === void 0 ? void 0 : _this3$selectedOrUser.split(',') : _this3.selectedOrUser(item.userKey) : [];
          var filteredSelectedOrUser = (0, _lodash.isArray)(selectedOrUserAry) && item.multiSelect ? selectedOrUserAry === null || selectedOrUserAry === void 0 ? void 0 : selectedOrUserAry.filter(function (value) {
            return optionsAry.indexOf(value) !== -1;
          }).join(',') : selectedOrUserAry;
          var hsh = {
            tagDisplay: item.forceTagDisplay || (0, _utils.formatFilterTag)(item, filteredSelectedOrUser),
            value: item.forceValue || filteredSelectedOrUser
          };
          return (0, _lodash.merge)(item, hsh);
        });
      }
    }, {
      key: "reviewDeckStore",
      get: function get() {
        return _state.AppUI.reviewDeckStore;
      }
    }, {
      key: "allReviewDeckOptions",
      get: function get() {
        var _AppUI$filteredReview,
          _this4 = this,
          _this$reviewDeckStore;
        return _state.AppUI.layout.isNative ? (_AppUI$filteredReview = _state.AppUI.filteredReviewDecks) === null || _AppUI$filteredReview === void 0 ? void 0 : _AppUI$filteredReview.map(function (item) {
          return _this4.reviewDeckToOption(item);
        }) : (_this$reviewDeckStore = this.reviewDeckStore.indexData.filter(function (item) {
          return !item.archived;
        })) === null || _this$reviewDeckStore === void 0 ? void 0 : _this$reviewDeckStore.map(function (item) {
          return _this4.reviewDeckToOption(item, {
            withLanguage: true
          });
        });
      }
    }, {
      key: "createdAtDaysAgoString",
      get: function get() {
        return this.createdAtDaysAgo ? "Created Last ".concat(this.createdAtDaysAgo, " Day").concat(this.createdAtDaysAgo > 1 ? 's' : '') : null;
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.disposer && this.disposer();
        this.resetSelectedCards();
      }
    }, {
      key: "sort",
      get: function get() {
        return this.selectedSort || _state.AppUI.user.reviewsListSort || 'review_after';
      }
    }, {
      key: "deck",
      get: function get() {
        var _this5 = this;
        return _state.AppUI.reviewDeckStore.indexData.find(function (item) {
          return item.id === _this5.deckId;
        });
      }
    }, {
      key: "cardType",
      get: function get() {
        var _this6 = this;
        return _state.AppUI.cardTypeStore.indexData.find(function (item) {
          return item.id === _this6.cardTypeId;
        });
      }
    }, {
      key: "deckId",
      get: function get() {
        return this.selectedOrUser('deck_id');
      }
    }, {
      key: "cardTypeId",
      get: function get() {
        return this.selectedOrUser('card_type_id');
      }
    }, {
      key: "createdAtDaysAgo",
      get: function get() {
        return this.selectedOrUser('created_at_days_ago');
      }
    }, {
      key: "reviewAfter",
      get: function get() {
        return this.selectedOrUser('review_after');
      }
    }, {
      key: "hasActiveFilter",
      get: function get() {
        return (0, _utils.isPresent)(this.filterSettings.filter(function (item) {
          return !item.hide && (0, _utils.isPresent)(item.value);
        }));
      }
    }, {
      key: "showPagination",
      get: function get() {
        return !this.showSpinner && (_state.AppUI.cardStore.page > 1 || _state.AppUI.cardStore.indexData.length > 0);
      }
    }, {
      key: "showSpinner",
      get: function get() {
        // return AppUI.cardStore.requestCounter > 0;
        return this.loadInitialReviews;
      }
    }, {
      key: "onDelete",
      value: function onDelete(id) {
        _state.AppUI.set('reloadReviewDecks', true);
        _state.AppUI.cardStore.set('indexData', _state.AppUI.cardStore.indexData.filter(function (item) {
          return item.id !== id;
        }));
        _state.AppUI.cardStore.destroy({
          ids: {
            cardId: id
          }
        }, this.getReviews);
      }
    }, {
      key: "onResetReview",
      value: function onResetReview(id) {
        var card = _state.AppUI.cardStore.indexData.find(function (item) {
          return item.id === id;
        });
        card.onResetReview();
        _state.DeckUI.updateSpacedRepetitionFields(card);
        _state.AppUI.cardStore.destroyReviews({
          ids: {
            cardId: card.id
          }
        }, _lodash.noop);
      }
    }, {
      key: "reloadCards",
      value: function reloadCards() {
        _state.AppUI.cardStore.reloadIndexFiltered({
          queryStrings: {
            my_reviews: true
          }
        });
      }
    }, {
      key: "filters",
      get: function get() {
        var filters = {};
        (0, _lodash.each)(this.filterSettings.filter(function (item) {
          return (0, _utils.isPresent)(item.value);
        }), function (item) {
          filters[item.key] = item.filterValue || item.value;
        });
        return filters;
      }
    }, {
      key: "keyIsMultiSelect",
      value: function keyIsMultiSelect(key) {
        var _this$filterSettings$;
        return (_this$filterSettings$ = this.filterSettings.find(function (item) {
          return item.userKey === key;
        })) === null || _this$filterSettings$ === void 0 ? void 0 : _this$filterSettings$.multiSelect;
      }
    }, {
      key: "onSetFilter",
      value: function onSetFilter(key, value) {
        var multiSelect = this.keyIsMultiSelect(key);
        this.resetSelectedCards();
        if (value === 'RANGE[,]') {
          value = null;
        }
        if (multiSelect) {
          this.updateMultipleSelectFilter(key, value);
        } else {
          this.selected[key] = value;
        }
        var data = {};
        data[key] = multiSelect ? this.selected[key].join(',') : value;
        _state.AppUI.cardStore.clearIndexData();
        this.loadInitialReviews = true;
        this.updateUser(data, this.getReviews);
      }
    }, {
      key: "updateMultipleSelectFilter",
      value: function updateMultipleSelectFilter(key, value) {
        if ((0, _utils.isBlank)(value) || !_state.AppUI.user[key]) {
          this.selected[key] = [];
        } else if ((0, _utils.isBlank)(this.selected[key]) && _state.AppUI.user[key]) {
          this.selected[key] = _state.AppUI.user[key].split(',');
        }
        if ((0, _utils.isPresent)(value) && this.selected[key].indexOf(value) === -1) {
          this.selected[key].push(value);
        } else if ((0, _utils.isPresent)(value)) {
          this.selected[key] = (0, _lodash.without)(this.selected[key], value);
        }
      }
    }, {
      key: "updateUser",
      value: function updateUser(data, callback) {
        var _this7 = this;
        (0, _lodash.each)((0, _lodash.keys)(data), function (key) {
          if (_state.AppUI.user) {
            _state.AppUI.user.set(key, data[key]);
          }
          if ((0, _utils.isBlank)(_this7.queuedUserData)) {
            _this7.queuedUserData = {};
          }
          if (_this7.userRequestIsPending) {
            _this7.queuedUserData[key] = data[key];
          }
        });
        if (!this.userRequestIsPending) {
          this.userRequestIsPending = true;
          if (callback) {
            this.callback = callback;
          }
          _state.AppUI.authUserStore.update({
            data: data
          }, this.afterRequest);
        }
      }
    }, {
      key: "afterRequest",
      value: function afterRequest() {
        this.userRequestIsPending = false;
        if ((0, _utils.isPresent)(this.queuedUserData)) {
          this.updateUser(this.queuedUserData);
          this.queuedUserData = {};
        } else {
          if (this.callback) {
            this.callback();
            this.callback = null;
          }
        }
      }
    }, {
      key: "activeFilter",
      value: function activeFilter(value) {
        return (0, _utils.isPresent)(value) && value !== 'any';
      }
    }, {
      key: "getReviews",
      value: function getReviews(callback) {
        var _this8 = this;
        _state.AppUI.cardStore.clearFilter();
        _state.AppUI.cardStore.setSort(this.sort);
        _state.AppUI.cardStore.setLimit(LIMIT);
        _state.AppUI.cardStore.getIndex({
          filters: this.filters,
          queryStrings: {
            my_reviews: true,
            language_id: _state.AppUI.targetLanguageId,
            search_query: (0, _utils.isPresent)(this.searchQuery) ? this.searchQuery : null
          }
        }, function (resp) {
          return _this8.afterGetReviews(resp, callback);
        });
      }
    }, {
      key: "onToggleFiltersExpanded",
      value: function onToggleFiltersExpanded() {
        this.filtersExpanded = !this.filtersExpanded;
        if (this.filtersExpanded) {
          _state.AppUI.expandModule('review-filters');
        } else {
          _state.AppUI.contractModule('review-filters');
        }
      }
    }, {
      key: "selectedOrUser",
      value: function selectedOrUser(key) {
        if (key in this.selected) {
          return this.selected[key];
        } else {
          return _state.AppUI.user[key];
        }
      }
    }, {
      key: "afterGetReviews",
      value: function afterGetReviews(resp, callback) {
        _state.AppUI.cardStore.setIndexData(resp);
        this.loadInitialReviews = false;
        if ((0, _lodash.isFunction)(callback)) {
          callback();
        }
      }
    }, {
      key: "onChangeSort",
      value: function onChangeSort(sort) {
        if (this.sort === sort && this.sort[0] !== '-') {
          this.selectedSort = "-".concat(sort);
        } else {
          this.selectedSort = sort;
        }
        this.getReviews();
        this.updateUser({
          reviews_list_sort: this.selectedSort
        }, _lodash.noop);
      }
    }, {
      key: "formatDateString",
      value: function formatDateString(beginDate, endDate) {
        if ((0, _utils.isPresent)(beginDate) || (0, _utils.isPresent)(endDate)) {
          var beginYear = beginDate ? (0, _moment["default"])(beginDate).format('YY') : null;
          var endYear = endDate ? (0, _moment["default"])(endDate).format('YY') : null;
          var currentYear = (0, _moment["default"])(new Date()).format('YY');
          var dateFormat = (0, _utils.isPresent)(beginYear) && beginYear < currentYear || (0, _utils.isPresent)(endYear) && endYear < currentYear ? 'MMM D \'YY' : 'MMM D';
          var str;
          if ((0, _utils.isPresent)(beginDate)) {
            str = (0, _moment["default"])(beginDate).format(dateFormat);
            if ((0, _utils.isBlank)(endDate)) {
              str = "After ".concat(str);
            }
          }
          if ((0, _utils.isPresent)(beginDate) && (0, _utils.isPresent)(endDate)) {
            str = "".concat(str, " - ").concat((0, _moment["default"])(endDate).format(dateFormat));
          } else if ((0, _utils.isPresent)(endDate)) {
            str = "Before ".concat((0, _moment["default"])(endDate).format(dateFormat));
          }
          return str;
        } else {
          return 'Any';
        }
      }
    }, {
      key: "onUpdateSearchQuery",
      value: function onUpdateSearchQuery(value, caretPosition) {
        this.searchQuery = value;
        this.caretPosition = caretPosition;
        clearInterval(this.interval);
        this.interval = setTimeout(this.getReviews, 500);
      }
    }, {
      key: "insertText",
      value: function insertText(text, caretPosition) {
        var newValue;
        if (!caretPosition) {
          caretPosition = this.searchQuery ? this.searchQuery.length : 0;
        }
        if (this.disabled) {
          return;
        }
        if (this.searchQuery) {
          newValue = [this.searchQuery.slice(0, caretPosition), text, this.searchQuery.slice(caretPosition)].join('');
        } else {
          newValue = text;
        }
        this.onUpdateSearchQuery(newValue, caretPosition + 1);
      }
    }, {
      key: "reviewDeckName",
      value: function reviewDeckName(reviewDeckId) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
          withLanguage: false
        };
        if (!this.reviewDeckStore.hasIndexData) {
          return '';
        }
        var reviewDeck = this.reviewDeckStore.indexData.find(function (item) {
          return item.id === reviewDeckId;
        });
        if ((0, _utils.isBlank)(reviewDeck)) {
          return '';
        }
        var reviewDeckName = reviewDeck.name;
        if (params['withLanguage'] && !reviewDeckName.startsWith(_constants.Languages[reviewDeck.languageId || 'DE'])) {
          reviewDeckName += " (".concat(_constants.Languages[reviewDeck.languageId || 'DE'], ")");
        }
        if (reviewDeck.archived) {
          reviewDeckName += ' [Archived]';
        }
        return reviewDeckName;
      }
    }, {
      key: "onToggleRetired",
      value: function onToggleRetired(cardId, retired) {
        _state.DeckUI.cardStore.update({
          ids: {
            cardId: cardId
          },
          data: {
            retired: retired
          }
        }, _lodash.noop);
      }
    }, {
      key: "setShowFilterOptions",
      value: function setShowFilterOptions(showFilterOptions) {
        this.showFilterOptions = showFilterOptions;
      }
    }, {
      key: "cardIsExpanded",
      value: function cardIsExpanded(card) {
        return this.expandedCardIds.includes(card.id);
      }
    }, {
      key: "cardIsSelected",
      value: function cardIsSelected(card) {
        return this.selectedCardIds.includes(card.id);
      }
    }, {
      key: "toggleCardExpand",
      value: function toggleCardExpand(card) {
        if (this.cardIsExpanded(card)) {
          (0, _lodash.remove)(this.expandedCardIds, function (item) {
            return item === card.id;
          });
        } else {
          this.expandedCardIds.push(card.id);
        }
      }
    }, {
      key: "toggleCardSelect",
      value: function toggleCardSelect(card) {
        if (this.cardIsSelected(card)) {
          (0, _lodash.remove)(this.selectedCardIds, function (item) {
            return item === card.id;
          });
        } else {
          this.selectedCardIds.push(card.id);
        }
      }
    }, {
      key: "frontText",
      value: function frontText(card) {
        var text;
        var MAX_LENGTH = _state.AppUI.layout.isMobile || _state.AppUI.layout.isNative ? 50 : 100;
        if (card.userSubmission && card.cardTypeSlug === 'user_submission') {
          text = card.frontText;
        }
        if (!(card.userSubmission && card.cardTypeSlug === 'user_submission') && card && card.word && !card.sentence) {
          text = card.word.targetTextWithDefiniteArticle;
        }
        if (!card.userSubmission && card.sentence) {
          text = (0, _src.displayTargetTextCorrectedForLanguage)(card.sentence.targetText, card.languageId);
        }
        if (text && text.length > MAX_LENGTH) {
          return "".concat(text.substring(0, MAX_LENGTH), "...");
        }
        return text;
      }
    }, {
      key: "cardDeckName",
      value: function cardDeckName(card) {
        var deckInfo = this.allReviewDeckOptions.find(function (option) {
          return option[0] == card.deckId;
        });
        return (0, _utils.isPresent)(deckInfo) ? deckInfo[1] : 'No Deck';
      }
    }, {
      key: "toggleExpandAll",
      value: function toggleExpandAll() {
        if (!this.allCardsExpanded && _state.DeckUI.cardStore.hasIndexData) {
          var _DeckUI$cardStore$ind;
          this.expandedCardIds = (_DeckUI$cardStore$ind = _state.DeckUI.cardStore.indexData) === null || _DeckUI$cardStore$ind === void 0 ? void 0 : _DeckUI$cardStore$ind.map(function (item) {
            return item.id;
          });
        } else {
          this.expandedCardIds = [];
        }
      }
    }, {
      key: "allCardsExpanded",
      get: function get() {
        var _DeckUI$cardStore$ind2;
        return _state.DeckUI.cardStore.hasIndexData && this.expandedCardIds.length === ((_DeckUI$cardStore$ind2 = _state.DeckUI.cardStore.indexData) === null || _DeckUI$cardStore$ind2 === void 0 ? void 0 : _DeckUI$cardStore$ind2.length);
      }
    }, {
      key: "allSelected",
      get: function get() {
        var _AppUI$cardStore$inde;
        return _state.AppUI.cardStore.hasIndexData && this.selectedCardIds.length === ((_AppUI$cardStore$inde = _state.AppUI.cardStore.indexData) === null || _AppUI$cardStore$inde === void 0 ? void 0 : _AppUI$cardStore$inde.length);
      }
    }, {
      key: "toggleSelectAll",
      value: function toggleSelectAll() {
        if (this.allSelected) {
          this.selectedCardIds = [];
        } else {
          var _DeckUI$cardStore$ind3;
          this.selectedCardIds = (_DeckUI$cardStore$ind3 = _state.DeckUI.cardStore.indexData) === null || _DeckUI$cardStore$ind3 === void 0 ? void 0 : _DeckUI$cardStore$ind3.map(function (item) {
            return item.id;
          });
        }
      }
    }, {
      key: "resetSelectedCards",
      value: function resetSelectedCards() {
        this.expandedCardIds = [];
        this.selectedCardIds = [];
      }
    }, {
      key: "cardTypeName",
      value: function cardTypeName(card) {
        if (_state.AppUI.cardTypeStore.hasIndexData) {
          var cardType = _state.AppUI.cardTypeStore.indexData.find(function (item) {
            return item.id === card.cardTypeId;
          });
          if (cardType) {
            return cardType.name;
          }
          return card.cardType.name;
        }
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          view: this.view,
          reviewDeckOptions: this.reviewDeckOptions,
          allReviewDeckOptions: this.allReviewDeckOptions,
          filtersExpanded: this.filtersExpanded,
          onToggleFiltersExpanded: this.onToggleFiltersExpanded,
          onSetFilter: this.onSetFilter,
          cardTypeId: this.cardTypeId,
          retired: this.retired,
          getReviews: this.getReviews,
          onChangeSort: this.onChangeSort,
          difficultyLabel: this.difficultyLabel,
          showSpinner: this.showSpinner,
          sort: this.sort,
          searchQuery: this.searchQuery,
          caretPosition: this.caretPosition,
          onUpdateSearchQuery: this.onUpdateSearchQuery,
          insertText: this.insertText,
          showPagination: this.showPagination,
          onDelete: this.onDelete,
          onResetReview: this.onResetReview,
          reviewDeckName: this.reviewDeckName,
          onToggleRetired: this.onToggleRetired,
          filterSettings: this.filterSettings,
          setShowFilterOptions: this.setShowFilterOptions,
          showFilterOptions: this.showFilterOptions,
          hasActiveFilter: this.hasActiveFilter,
          noFiltersSelectedMessage: this.noFiltersSelectedMessage,
          filteredItemsCount: this.filteredItemsCount,
          page: _state.AppUI.cardStore.page,
          expandedCardIds: this.expandedCardIds,
          selectedCardIds: this.selectedCardIds,
          cardIsExpanded: this.cardIsExpanded,
          cardIsSelected: this.cardIsSelected,
          toggleCardExpand: this.toggleCardExpand,
          toggleCardSelect: this.toggleCardSelect,
          frontText: this.frontText,
          cardDeckName: this.cardDeckName,
          toggleExpandAll: this.toggleExpandAll,
          allCardsExpanded: this.allCardsExpanded,
          resetSelectedCards: this.resetSelectedCards,
          allSelected: this.allSelected,
          toggleSelectAll: this.toggleSelectAll,
          cardTypeName: this.cardTypeName,
          cardDeckIsArchived: this.cardDeckIsArchived
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "selected", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return {};
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "view", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return 'card';
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "filtersExpanded", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return true;
    }
  }), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "userRequestIsPending", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "loadInitialReviews", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "selectedSort", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "searchQuery", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "caretPosition", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "showFilterOptions", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "expandedCardIds", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return [];
    }
  }), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, "selectedCardIds", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return [];
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "filteredItemsCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "filteredItemsCount"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "noFiltersSelectedMessage", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "noFiltersSelectedMessage"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "sortNonArchivedFirst", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "sortNonArchivedFirst"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "reviewDeckToOption", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "reviewDeckToOption"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "reviewDeckOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "reviewDeckOptions"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "cardDeckIsArchived", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "cardDeckIsArchived"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "filterSettings", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "filterSettings"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "reviewDeckStore", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "reviewDeckStore"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "allReviewDeckOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "allReviewDeckOptions"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "createdAtDaysAgoString", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "createdAtDaysAgoString"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "sort", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "sort"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "deck", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "deck"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "cardType", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "cardType"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "deckId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "deckId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "cardTypeId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "cardTypeId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "createdAtDaysAgo", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "createdAtDaysAgo"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "reviewAfter", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "reviewAfter"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hasActiveFilter", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hasActiveFilter"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showPagination", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showPagination"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showSpinner", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showSpinner"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onDelete", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onDelete"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onResetReview", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onResetReview"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "reloadCards", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "reloadCards"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "filters", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "filters"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "keyIsMultiSelect", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "keyIsMultiSelect"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onSetFilter", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onSetFilter"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "updateMultipleSelectFilter", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "updateMultipleSelectFilter"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "updateUser", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "updateUser"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterRequest", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "afterRequest"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "activeFilter", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "activeFilter"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "getReviews", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "getReviews"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onToggleFiltersExpanded", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onToggleFiltersExpanded"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "selectedOrUser", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "selectedOrUser"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterGetReviews", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "afterGetReviews"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onChangeSort", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onChangeSort"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "formatDateString", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "formatDateString"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onUpdateSearchQuery", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onUpdateSearchQuery"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "insertText", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "insertText"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "reviewDeckName", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "reviewDeckName"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onToggleRetired", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onToggleRetired"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "setShowFilterOptions", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "setShowFilterOptions"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "cardIsExpanded", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "cardIsExpanded"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "cardIsSelected", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "cardIsSelected"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "toggleCardExpand", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "toggleCardExpand"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "toggleCardSelect", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "toggleCardSelect"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "frontText", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "frontText"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "cardDeckName", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "cardDeckName"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "toggleExpandAll", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "toggleExpandAll"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "allCardsExpanded", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "allCardsExpanded"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "allSelected", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "allSelected"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "toggleSelectAll", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "toggleSelectAll"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "resetSelectedCards", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "resetSelectedCards"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "cardTypeName", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "cardTypeName"), _class2.prototype), _class2)) || _class;
};
ReviewIndexWrapper.displayName = 'ReviewIndexWrapper';
var _default = exports["default"] = ReviewIndexWrapper;